import React, { useCallback, useEffect, useState } from "react";
import AssetUpload from "./AssetUpload";
import { getAssets } from "../../store/api/assets";
import { ASSET_CATEGORIES } from "../../constants";
import { Alert, Skeleton, Space } from "antd";

const Banner = () => {
  const [loading, setLoading] = useState(false);
  const [assets, setAssets] = useState([]);

  const fetchData = useCallback(() => {
    setLoading(true);
    getAssets({ category: ASSET_CATEGORIES.HOME_BANNER })
      .then(({ data }) => {
        setAssets(data.assets);
      })
      .catch(() => {
        //
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="home-banner">
      <h3 style={{ fontWeight: "bold" }}>Banner images</h3>
      <p style={{ color: "#777777" }}>
        Images to show on carousel (banner) in the home page.
      </p>
      {loading ? (
        <Space>
          <Skeleton.Image active={loading} />
          <Skeleton.Image active={loading} />
        </Space>
      ) : (
        <>
          <Alert
            message="Recommened image sie: max 2MB."
            type="warning"
            style={{ marginTop: "4px", marginBottom: "16px" }}
          ></Alert>
          <AssetUpload assets={assets} />
        </>
      )}
    </section>
  );
};

export default Banner;
